(function() { module.exports = window["wp"]["blob"]; }());